import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import './loading.scss';
import clsx from 'clsx';
import LoadingMessages from './loading-messages';

const DELAY = 1000;

const Loading = ({ withMessage, delay, currentMessage }) => {
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    const sto = setTimeout(() => setRendered(true), delay);

    return () => clearTimeout(sto);
  }, [setRendered]);

  return (
    <div className={clsx('loading-cont', { rendered })}>
      <div className="loading-animation" />
      {withMessage && (
      <div className="loading-message">
        {currentMessage || LoadingMessages[Math.floor(Math.random() * 10)]}
      </div>
      )}
    </div>
  );
};

Loading.defaultProps = {
  withMessage: true,
  delay: DELAY,
  currentMessage: '',
};

Loading.propTypes = {
  withMessage: PropTypes.bool,
  delay: PropTypes.number,
  currentMessage: PropTypes.string,
};

Loading.defaultProps = {};

export default Loading;
